import { useRef, useState } from 'react';

// Shows the poster with a play button, and only loads the video once it is clicked.
export default function TrailerVideo({ src, poster, title }) {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const play = () => {
    setStarted(true);
    videoRef.current?.play();
  };

  return (
    <div className="relative aspect-video rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-black shadow-xl">
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        preload="none"
        playsInline
        controls={started}
        className="w-full h-full"
        aria-label={title}
      />
      {!started && (
        <button
          type="button"
          onClick={play}
          aria-label={`Play ${title}`}
          className="group absolute inset-0 flex items-center justify-center bg-black/20 hover:bg-black/10 transition-colors"
        >
          <span className="flex items-center justify-center w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 text-white shadow-lg group-hover:scale-105 transition-transform">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-9 h-9 md:w-11 md:h-11 ml-1">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
}
